import { styled } from "@mui/material/styles"
import Box from "@mui/material/Box"
import { TextField } from "@mui/material"

const StyledIcon = styled(Box)(({ theme, color }) => ({
  color: color.toString(),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 0,
  marginInline: "auto",
  "& svg": {
    width: "8rem",
    height: "8rem",
  },
  [theme.breakpoints.down("md")]: {
    minWidth: 0,
    width: "8rem",
    height: "8rem",
    "& svg": {
      width: "8rem",
      height: "8rem",
    },
  },
}))

const StyledTextField = styled(TextField)(({ theme, color }) => ({
  "& .MuiOutlinedInput-notchedOutline legend": { display: "none" },
}))

export { StyledIcon, StyledTextField }
